export default __webpack_public_path__ + "static/media/tutorial2-5.466045b7.png";